import api from "./api";

const adminService = {
  updateConfiguration: async (key: string, data: any) => {
    const response = await api.put(`/admin/configurations/${key}`, data);
    return response.data;
  },

  getConfigurations: async () => {
    try {
      const response = await api.get("/admin/configurations");
      console.log("Configurations raw response:", response);
      return response;
    } catch (error) {
      console.error("Configurations API error:", error);
      throw error;
    }
  },

  getUsers: async (params?: any) => {
    try {
      const response = await api.get("/admin/users", { params });
      console.log("Users raw response:", response);
      return response;
    } catch (error) {
      console.error("Users API error:", error);
      throw error;
    }
  },

  getUserMetrics: async (userId: number) => {
    try {
      const response = await api.get(`/admin/users/${userId}/metrics`);
      console.log("User metrics raw response:", response);
      return response;
    } catch (error) {
      console.error("User metrics API error:", error);
      throw error;
    }
  },

  generateHistoricalData: async (data: any) => {
    try {
      const response = await api.post("/admin/data-generation", data);
      console.log("Generate data response:", response);
      return response;
    } catch (error) {
      console.error("Generate data API error:", error);
      throw error;
    }
  },

  // User Management
  createUser: async (data: any) => {
    const response = await api.post("/admin/users", data);
    return response.data;
  },

  updateUser: async (id: number, data: any) => {
    const response = await api.put(`/admin/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id: number) => {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  toggleUserRole: async (id: number) => {
    const response = await api.post(`/admin/users/${id}/toggle-role`);
    return response.data;
  },

  updateUserBalance: async (data: { id: number; balance: number }) => {
    const response = await api.put(`/admin/users/${data.id}/balance`, {
      balance: data.balance,
    });
    return response.data;
  },

  sendUserEmail: async (
    id: number,
    data: { subject: string; message: string },
  ) => {
    const response = await api.post(`/admin/users/${id}/send-email`, data);
    return response.data;
  },

  // Data Generation
  getGenerationHistory: async (params?: any) => {
    const response = await api.get("/admin/generation-history", { params });
    return response.data;
  },

  getTemplates: async () => {
    const response = await api.get("/admin/templates");
    return response.data;
  },

  // Statistics
  getStatistics: async () => {
    const response = await api.get("/admin/statistics");
    return response.data;
  },
};

export default adminService;
